/* eslint-disable */import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FloatingActionButton } from '@progress/kendo-react-buttons';
import PopUpButton, { INTERNAL_BUTTON, INTERNAL_ITEMS } from '../../components/button';
import { CalendarWithButtons, DateFilter } from '../../components/dateComponents';
import Table from '../../components/table';
import PopUpConfirm from '../../components/popUps/popUpConfirm';
import PopUpError from '../../components/popUps/popUpError';
import './styles.css';
import LoadScreen from '../load';
import * as scheduleService from '../../services/schedule';
import { successNotification, errorNotification } from '../../components/notification';
import { FirstDayOfMonth, LastDayOfMonth, DateNow } from '../../utils/date';
import PopUpViewer from '../../components/popUps/popUpViewer';
import PopUpSettings from '../../components/popUps/popUpSettings';
import PopUpSchedule from '../../components/popUps/popUpSchedule';
import { useQuery } from '../../hooks';
import { scheduleStatus, scheduleStatusText } from '../../utils/status';

const Schedules = () => {
  const [reload, setReload] = useState(0);
  const { id } = useParams();
  const query = useQuery();
  const editId = window.localStorage.getItem('EDIT_ID');
  const history = useHistory();
  const [schedules, setSchedules] = useState([]);
  const [schedulesSelectedsIds, setSchedulesSelectedsIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [popUpConfirmDelete, setPopUpConfirmDelete] = useState(false);
  const [popUpConfirmSale, setPopUpConfirmSale] = useState(false);
  const [popUpError, setPopUpError] = useState(false);
  const [popUpErrorTitle, setPopUpErrorTitle] = useState('');
  const [popUpErrorMessage, setPopUpErrorMessage] = useState('');
  const [rowIndex, setRowIndex] = useState(0);
  const [popUpConfirmContract, setPopUpConfirmContract] = useState(false);
  const [popUpConfirmPDF, setPopUpConfirmPDF] = useState(false);
  const [popUpViewer, setPopUpViewer] = useState(false);
  const [dataViewer, setDataViewer] = useState(null);
  const [popUpSettings, setPopUpSettings] = useState(false);
  const [popUpSchedule, setPopUpSchedule] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const filterDateLocal1 = window.localStorage.getItem('SCHEDULE_FILTER_DATE1');
  const filterDateLocal2 = window.localStorage.getItem('SCHEDULE_FILTER_DATE2');
  const dateNow = DateNow();
  let filterDate = { date1: FirstDayOfMonth(dateNow), date2: LastDayOfMonth(dateNow) };
  if (filterDateLocal1 && id)
    filterDate = { date1: new Date(filterDateLocal1), date2: new Date(filterDateLocal2) };
  const [date, setDate] = useState(filterDate);
  const filterTypeLocal = window.localStorage.getItem('SCHEDULE_FILTER_TYPE');
  const [filterType, setFilterType] = useState(filterTypeLocal || 'day');

  window.localStorage.setItem('SCHEDULE_FILTER_DATE1', date.date1);
  window.localStorage.setItem('SCHEDULE_FILTER_DATE2', date.date2);
  window.localStorage.setItem('SCHEDULE_FILTER_TYPE', filterType);

  const columns = [
    {
      field: 'Situacao',
      title: 'Sit.',
      width: 50,
      cell: (props) => {
        const td = scheduleStatus(props.dataItem.SituacaoId);
        return td;
      },
      columnMenuCheckbox: true
    },
    {
      field: 'Data',
      title: 'Data de Agendamento',
      filter: 'date',
      format: '{0:dd/MM/yyyy HH:mm:ss}',
      isCenter: true,
      isThrough: true,
      width: 110,
      columnMenu: true
    },
    {
      field: 'Descricao',
      title: 'Interação',
      width: 200,
      isThrough: true,
      columnMenu: true,
      columnMenuCheckbox: true
    },
    {
      field: 'TipoRelacionamentoNome',
      title: 'Tipo',
      columnMenu: true,
      columnMenuCheckbox: true
    },
    {
      field: 'SituacaoRelacionamentoNome',
      title: 'Situação',
      columnMenu: true,
      columnMenuCheckbox: true
    },
    {
      field: 'DataRegistro',
      title: 'Data de Registro',
      filter: 'date',
      format: '{0:dd/MM/yyyy}',
      isCenter: true,
      width: 110,
      columnMenu: true
    },
    {
      field: 'DataUltimaInteracao',
      title: 'Última Interação',
      filter: 'date',
      format: '{0:dd/MM/yyyy}',
      isCenter: true,
      width: 110,
      columnMenu: true
    },
    {
      field: 'Numero',
      title: 'Núm.',
      width: 60,
      isRight: true,
      columnMenuCheckbox: true
    },
    {
      field: 'PessoaNome',
      title: 'Nome',
      width: 300,
      columnMenu: true,
      columnMenuCheckbox: true
    },
    {
      field: 'Contato',
      title: 'Contato',
      columnMenu: true
    },
    {
      field: 'Celular',
      title: 'Celular',
      columnMenu: true,
      cell: (props) => {
        let td = null;
        if (props.dataItem.Celular) {
          const celularTratado = props.dataItem.Celular.replace(/[^0-9]/g, '');
          td = (
            <td>
              <a
                className="link-left"
                href={`https://api.whatsapp.com/send?phone=${celularTratado}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {props.dataItem.Celular}
              </a>
            </td>
          );
        } else {
          td = <td>{props.dataItem.name}</td>;
        }
        return td;
      }
    },
    {
      field: 'Titulo',
      title: 'Título',
      columnMenu: true
    },
    {
      field: 'OrigemRelacionamentoNome',
      title: 'Origem',
      columnMenu: true,
      columnMenuCheckbox: true
    },
    {
      field: 'PrioridadeNome',
      title: 'Prioridade',
      columnMenu: true,
      columnMenuCheckbox: true
    },
    {
      field: 'ResponsavelNome',
      title: 'Responsável',
      columnMenu: true,
      columnMenuCheckbox: true
    }
  ];

  const seekScroll = async (data) => {
    if (editId != null) {
      const index = data.findIndex((item) => item.Id === editId);
      setRowIndex(index);
    } else {
      setRowIndex(data.length - 1);
    }
  };

  const fetchSchedules = async () => {
    const dateInterval = {
      DataInicio: date.date1,
      DataFim: date.date2
    };
    const response = await scheduleService.getScheduleByDate(dateInterval);
    let { data } = response;
    data = data.map((item) => {
      const data = new Date(`${item.Data}Z`);
      const dataRegistro = new Date(`${item.Relacionamento.Data}Z`);
      const dataUltimaInteracao = new Date(`${item.Relacionamento.DataUltimaInteracao}Z`);
      data.setHours(0, 0, 0, 0);
      dataUltimaInteracao.setHours(0, 0, 0, 0);
      return {
        ...item,
        ...item.Relacionamento,
        Id: item.Id,
        Data: data,
        DataRegistro: dataRegistro,
        DataUltimaInteracao: dataUltimaInteracao,
        Descricao: item.Descricao,
        Situacao: scheduleStatusText(item.SituacaoId),
        Through: item.SituacaoId === 1
      };
    });
    setSchedules(data);
    seekScroll(data);
  };

  const excludeSchedules = async () => {
    setLoading(true);
    const excludeSchedulesRequests = schedulesSelectedsIds.map((relationshipSelected) =>
      scheduleService.excludeRelationshipSchedule(relationshipSelected)
    );

    const excludeSchedulesResponses = await Promise.all(excludeSchedulesRequests);

    const isAllRequestsRight = excludeSchedulesResponses.reduce(
      (acc, currentResponse) => acc && currentResponse.status === 200,
      true
    );

    setSchedulesSelectedsIds([]);
    setLoading(false);
    setPopUpConfirmDelete(false);
    if (isAllRequestsRight) successNotification('Registro(s) excluído(s) com sucesso!');
    else {
      const erro = ['Houve um erro ao tentar excluir uma ou mais registros:'];
      excludeSchedulesResponses.forEach((element) => {
        const { data } = element;
        if (data.MensagemUsuario !== undefined) erro.push(data.MensagemUsuario);
        else erro.push(data);
      });
      setPopUpErrorTitle('Erro ao Excluir Registro');
      setPopUpErrorMessage(erro);
      setPopUpError(true);
    }
    await fetchSchedules();
  };

  const updateSchedule = async (schedule) => {
    const response = await scheduleService.updateRelationshipSchedule(
      schedule,
      selectedSchedule.Id
    );
    if (response.status === 200) {
      setSelectedSchedule(null);
      setLoading(true);
      await fetchSchedules();
      setLoading(false);
      successNotification('Agenda atualizada com sucesso!');
    } else {
      const { data } = response;
      if (data.MensagemUsuario !== undefined) errorNotification(data.MensagemUsuario);
      else errorNotification(data);
    }
  };

  useEffect(async () => {
    setLoading(true);
    await fetchSchedules();
    setLoading(false);
  }, [date, reload]);

  return loading ? (
    <LoadScreen />
  ) : (
    <>
      <div id="schedule-list">
        <h1>Agenda</h1>
        <div className="buttons-schedule-list">
          {filterType === 'month' && (
            <CalendarWithButtons
              date={date.date1}
              setDate={(val) => {
                const date1 = FirstDayOfMonth(val);
                const date2 = LastDayOfMonth(val);
                setDate({ date1, date2 });
                window.localStorage.setItem('SCHEDULE_FILTER_DATE1', date1);
                window.localStorage.setItem('SCHEDULE_FILTER_DATE2', date2);
              }}
              service={scheduleService}
            />
          )}
          {filterType === 'day' && (
            <DateFilter
              date1={date.date1}
              date2={date.date2}
              setDate={(date1, date2) => {
                setDate({ date1, date2 });
                window.localStorage.setItem('SCHEDULE_FILTER_DATE1', date1);
                window.localStorage.setItem('SCHEDULE_FILTER_DATE2', date2);
              }}
            />
          )}
          <div className="config-components-popup-button">
            <FloatingActionButton
              icon={INTERNAL_BUTTON.BUTTON_REFRESH}
              onClick={() => {
                setReload((prev) => prev + 1);
              }}
            />
          </div>

          <PopUpButton
            internalButton={INTERNAL_BUTTON.BUTTON_THREEPOINTS}
            internalItems={[
              {
                id: INTERNAL_ITEMS.CONFIGURAR,
                onClick: () => setPopUpSettings(true),
                text: 'Configurar Tela'
              }
            ]}
          />
        </div>
        <Table
          name="Schedules"
          data={schedules}
          columns={columns}
          dataItemKey="Id"
          setItemKeysSelected={setSchedulesSelectedsIds}
          style={{ minHeight: 500, marginTop: 20, height: '100%' }}
          onClickInRow={(dataItem) => {
            setPopUpSchedule(true);
            setSelectedSchedule(dataItem);
          }}
          sortable={true}
          rowIndex={rowIndex}
        />
      </div>
      <PopUpConfirm
        onConfirm={excludeSchedules}
        visible={popUpConfirmDelete}
        setVisible={setPopUpConfirmDelete}
        title="Confirmação"
        message="Você tem certeza que deseja excluir o(s) registros(s) selecionado(s)?"
      />
      <PopUpViewer
        visible={popUpViewer}
        setVisible={setPopUpViewer}
        title="Pré-visualização"
        data={dataViewer}
        type="application/pdf"
      />
      <PopUpError
        visible={popUpError}
        setVisible={setPopUpError}
        title={popUpErrorTitle}
        message={popUpErrorMessage}
      />
      <PopUpSettings
        onConfirm={(val) => {
          setFilterType(val);
          window.localStorage.setItem('SCHEDULE_FILTER_TYPE', val);
        }}
        visible={popUpSettings}
        setVisible={setPopUpSettings}
        title="Preferências"
        filter={filterType}
      />
      <PopUpSchedule
        visible={popUpSchedule}
        setVisible={setPopUpSchedule}
        addSchedule={updateSchedule}
        selectedSchedule={selectedSchedule}
      />
    </>
  );
};

export default Schedules;
